import axios from '../../../api.service'

export default {
  async fetchCountriesList({ dispatch, commit }) {
    const api = '/frontend/country'
    const response = await axios.get(api)
    commit('SET_COUNTRIES', response?.data)
  },
}
